import { render, staticRenderFns } from "./ConfirmRow.vue?vue&type=template&id=6635eb36&lang=pug"
import script from "./ConfirmRow.vue?vue&type=script&lang=js"
export * from "./ConfirmRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TypedDateInput: require('/home/docker/code/frontend/components/TypedDateInput.vue').default})
